import { listGender, listMarriage } from "data/list";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";

const {
  INPUT,
  SELECT,
  DATE_DAY_INPUT,
  DATE_DISABLE_NO_DAY,
  DATE,
  COMBO_BOX,
  AUTO_COMPLETE,
  NUMBER,
  TEXT_AREA,
  CHECKBOX
} = FIELD_TYPE;
const TEL_NUMBER_REGEX = /^\d+$/;

const validatePhoneNumber = (rule, value) => {
  if (!TEL_NUMBER_REGEX.test(value)) {
    return Promise.reject("Chỉ cho phép nhập số");
  } else if (value.length > 11) {
    return Promise.reject("Số điện thoại tối đa 11 chữ số");
  } else if (value.length < 10) {
    return Promise.reject("Số điện thoại tối thiểu 10 chữ số");
  } else {
    return Promise.resolve();
  }
};
const fields: any[] = [
  {
    type: INPUT,
    label: "Mã nhân viên",
    name: "maNhanVien",
    disable: true,
    rules: [
      { required: true, message: "Chưa nhập mã nhân viên" },
      {
        pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        message: "Chỉ cho phép nhập số",
      },
    ],
  },
  // {
  //     type: INPUT,
  //     label: "MNV Emp Code",
  //     name: "empCode",
  //     disable: true,
  //     rules: [{required: true, message: "Chưa nhập MNV EmpCode"},
  //     {
  //         pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
  //         message: "Chỉ cho phép nhập số"
  //     }],
  // },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: true,
    rules: [{ required: true, message: "Chưa nhập họ tên" }],
  },
  {
    type: DATE_DAY_INPUT,
    label: "Ngày sinh",
    name: "birthday",
    // optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    disable: true,
    rules: [{ required: true, message: "Chưa nhập ngày sinh" }],
  },
  {
    type: COMBO_BOX,
    label: "Giới tính",
    name: "idGioiTinh",
    disable: true,
    options: listGender,
    rules: [{ required: true, message: "Chưa nhập giới tính" }],
  },
  {
    type: INPUT,
    label: "TK đăng nhập",
    name: "taiKhoanDangNhap",
    disable: true,
  },
  {
    type: AUTO_COMPLETE,
    label: "Người quản lý trực tiếp",
    name: "nguoiQuanLyTrucTiep",
    disable: true,
  },
  {
    type: INPUT,
    label: "Nơi sinh",
    name: "noiSinh",
    disable: true,
  },
  {
    type: INPUT,
    label: "Hộ khẩu",
    name: "hoKhau",
    disable: true,
    // placeholder: "Không có",
  },
  {
    type: COMBO_BOX,
    label: "Quốc tịch",
    name: "quocTich",
    expand: false,
    disable: true,
    // placeholder: "Không có",
  },
  {
    type: COMBO_BOX,
    label: "Tôn Giáo",
    name: "tonGiao",
    expand: false,
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Dân tộc",
    name: "danToc",
    expand: false,
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "TT hôn nhân",
    name: "tinhTrangHonNhan",
    disable: true,
    options: listMarriage,
  },

  {
    type: AUTO_COMPLETE,
    label: "Học vấn cao nhất",
    name: "hocVanCaoNhat",
    disable: true,
    options: [
      { value: "Đại học", label: "Đại học" },
      { value: "Cao Đẳng", label: "Cao Đẳng" },
    ],
  },
  {
    type: INPUT,
    label: "Trường",
    name: "truong",
    disable: true,
  },
  {
    type: INPUT,
    label: "Chuyên ngành",
    name: "chuyenNganh",
    disable: true,
    // options: [
    //   { value: "CNTT", label: "CNTT" },
    //   { value: "Quản Trị", label: "Quản Trị" },
    // ],
  },
  {
    type: INPUT,
    label: "ĐT di động",
    name: "dienThoaiDiDong",
    disable: true,
    placeholder: "Không có",
    // rules: [
    //   {
    //     validator: validatePhoneNumber,
    //    // required: false,
    //   },
    // ],
    rules: [
      {
        pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        message: "Chỉ cho phép nhập số",
      },
      {
        max: 11,
        min: 10,
        message: "Định dạng SĐT không đúng",
      },
    ],
  },
  {
    type: INPUT,
    label: "Email cá nhân",
    name: "emailCaNhan",
    disable: true,
    placeholder: "Không có",
    rules: [
      {
        pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        message: "Định dạng email không đúng",
      },
    ],
  },
  {
    type: INPUT,
    label: "Email công ty",
    name: "emailCongTy",
    disable: true,
    // placeholder: "Không có",
    rules: [
      {
        pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        message: "Định dạng email không đúng",
      },
    ],
  },
  {
    type: INPUT,
    label: "Số CCCD/CMT",
    name: "cccd",
    disable: true,
    rules: [
      {
        pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        message: "Chỉ cho phép nhập số",
      },
      {
        max: 12,
        min: 9,
        message: "Định dạng CCCD/CMT không đúng",
      },
    ],
    // placeholder: "Không có",
  },
  {
    type: DATE_DAY_INPUT,
    label: "Ngày cấp",
    name: "ngayCapDto",
    disable: true,
    placeholder: "Không có",
    // optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: COMBO_BOX,
    label: "Nơi cấp",
    name: "noiCap",
    disable: true,
    // placeholder: "Không có",
  },
  {
    type: INPUT,
    label: "Số người giảm trừ gia cảnh",
    name: "soNguoiPhuThuoc",
    disable: true,
    rules: [
      {
        pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        message: "Chỉ cho phép nhập số",
      },
    ],
    // placeholder: "Không có",
  },
  {
    name: "idVaiTro",
    type: CHECKBOX,
    label: "Vai trò",
    disable: true,
    checkbox: [
      {
        label: "Bác sĩ",
        value: 1,
        span: 32,
      },
    ],
  },
  {
    type: INPUT,
    label: "ĐC thường trú",
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
    name: "diaChiThuongTru",
    disable: true,
  },
  {
    type: INPUT,
    label: "ĐC liên hệ",
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
    name: "diaChiLienHe",
    disable: true,
  },
  {
    type: TEXT_AREA,
    label: "Ghi chú",
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
    name: "ghiChu",
    disable: true,
  },

  {
    type: DATE_DAY_INPUT,
    label: "Ngày vào làm",
    name: "ngayVaoLam",
    disable: true,
    disableDate: false,
    placeholder: "Không có",
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: DATE_DAY_INPUT,
    label: "Ngày nghỉ việc",
    name: "ngayNghiViec",
    disable: true,
    disabledDate: false,
    placeholder: "Không có",
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: INPUT,
    label: "Lý do nghỉ",
    name: "lyDoNghiViec",
    disable: true,
    // placeholder: "Không có",
  },
];
export { fields };
